/**
 * Settings types for ReefDataHub
 */

export interface TargetRange {
  parameterId: string;
  parameterName: string;
  unit: string;
  minValue: number | null;
  maxValue: number | null;
  enabled: boolean;
}

export interface TankTargetRanges {
  tankId: string;
  ranges: TargetRange[];
}

// Default parameters for target range configuration
export const DEFAULT_PARAMETERS = [
  { id: 'ph', name: 'pH', unit: '', defaultMin: 7.8, defaultMax: 8.4 },
  { id: 'temperature', name: 'Temperature', unit: '°C', defaultMin: 24, defaultMax: 27 },
  { id: 'salinity', name: 'Salinity', unit: 'ppt', defaultMin: 34, defaultMax: 36 },
  { id: 'alkalinity', name: 'Alkalinity (dKH)', unit: 'dKH', defaultMin: 7, defaultMax: 11 },
  { id: 'calcium', name: 'Calcium', unit: 'ppm', defaultMin: 380, defaultMax: 450 },
  { id: 'magnesium', name: 'Magnesium', unit: 'ppm', defaultMin: 1250, defaultMax: 1450 },
  { id: 'nitrate', name: 'Nitrate (NO3)', unit: 'ppm', defaultMin: 0, defaultMax: 10 },
  { id: 'phosphate', name: 'Phosphate (PO4)', unit: 'ppm', defaultMin: 0, defaultMax: 0.1 },
];
